import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../elements/tab/materialTabPanel";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import queryString from "query-string";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledTelegramBotWrapper } from "../styledTelegramBot";
import { StyledTabsBody, StyledTabsHead } from "../../styles/styledTabs";
import TelegramBotsContainer from "./bots/TelegramBotsContainer";
import TelegramChatsContainer from "./chats/TelegramChatsContainer";
import TelegramManagersContainer from "./managers/TelegramManagersContainer";
import TelegramConnectionsContainer from "./connections/TelegramConnectionsContainer";
import TelegramDrainWalletsContainer from "./drainWallets/TelegramDrainWalletsContainer";
import TelegramInvoicesContainer from "./invoices/TelegramInvoicesContainer";

const DEFAULT_TAB = "bots";

const TAB_INDEX = {
  bots: 0,
  chats: 1,
  managers: 2,
  connections: 3,
  drainWallets: 4,
  invoices: 5,
};

const TelegramChatsTabsContainer = () => {
  const { t } = useTranslation("telegramBotPage");
  const history = useHistory();

  const queryParams = queryString.parse(history.location.search);
  const tabValue = TAB_INDEX[queryParams.currentTab] ?? 0;

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };

  return (
    <StyledContentWrapper>
      <StyledTelegramBotWrapper>
        <StyledTabsHead className="tab-head" orientation="horizontal">
          <Tabs
            value={queryParams?.currentTab ?? DEFAULT_TAB}
            indicatorColor="secondary"
            onChange={handleChange}
            orientation="horizontal"
            className="tab-head-buttons"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label={t("pageTabs.bots")} value="bots" />
            <Tab label={t("pageTabs.chats")} value="chats" />
            <Tab label={t("pageTabs.managers")} value="managers" />
            <Tab label={t("pageTabs.connections")} value="connections" />
            <Tab label={t("pageTabs.drainWallets")} value="drainWallets" />
            <Tab label={t("pageTabs.invoices")} value="invoices" />
          </Tabs>
        </StyledTabsHead>
        <StyledTabsBody className="tab-body">
          <TabPanel value={tabValue} index={0}>
            <TelegramBotsContainer />
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <TelegramChatsContainer />
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            <TelegramManagersContainer />
          </TabPanel>
          <TabPanel value={tabValue} index={3}>
            <TelegramConnectionsContainer />
          </TabPanel>
          <TabPanel value={tabValue} index={4}>
            <TelegramDrainWalletsContainer />
          </TabPanel>
          <TabPanel value={tabValue} index={5}>
            <TelegramInvoicesContainer />
          </TabPanel>
        </StyledTabsBody>
      </StyledTelegramBotWrapper>
    </StyledContentWrapper>
  );
};

export default TelegramChatsTabsContainer;